import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import { Text } from '@hub/text';
import { FeatureFlagsContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
const EventNotification = _ref => {
  let {
    className,
    message = '*Upcoming events are subject to change',
    sx
  } = _ref;
  const IS_EVENT_NOTY = useContext(FeatureFlagsContext).NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY;
  if (IS_EVENT_NOTY) {
    return /*#__PURE__*/_jsx(Text, {
      as: "p",
      sx: _objectSpread({
        fontSize: 'font-body'
      }, sx),
      className: className,
      "data-id": "event-notification_index_EventNotification_Text",
      children: message
    });
  }
  return null;
};
export default EventNotification;